import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { navigationEvents } from 'routes/utils/navigationEvents';

export const NavigationEventListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Listen for navigation events and handle them with hooks
    const unsubscribeNavigate = navigationEvents.on(
      'navigate',
      (path, options) => {
        navigate(path, options);
      }
    );

    const unsubscribeGoBack = navigationEvents.on('goBack', () => {
      navigate(-1);
    });

    const unsubscribeGoForward = navigationEvents.on('goForward', () => {
      navigate(1);
    });

    // Cleanup subscriptions
    return () => {
      unsubscribeNavigate();
      unsubscribeGoBack();
      unsubscribeGoForward();
    };
  }, [navigate]);

  return null;
};
